<template>
  <div >
    <div  v-if="nota_part || nota_part != null" class="md-layout noprint">
      <md-toolbar class="color md-dense">
        <h3 class="md-title" style="flex:1;">
        </h3>
        <md-button style="float: right; " class="noprint md-dense md-icon-button color" @click="printPage()" ><md-icon>print</md-icon></md-button>
        <!-- <md-menu md-direction="bottom-start" style="margin-right:20px;">
          <md-button class="nonprint; md-info md-dense md-icon-button" md-menu-trigger><md-icon>more_vert</md-icon></md-button>
          <md-menu-content>
            <md-menu-item v-if="role.update" @click="editNotaPart(nota_part.id)">Edit</md-menu-item>
            <md-menu-item v-if="role.delete" @click="deleteConfirmation(nota_part.id)">Delete</md-menu-item>
            <md-menu-item @click="backtoList">Back to NP list</md-menu-item>
          </md-menu-content>
        </md-menu> -->
        <md-button class="md-icon-button md-dense color color" @click="closeDetail()"><md-icon>close</md-icon></md-button>
      </md-toolbar>
      <div class="md-layout-item md-size-100">
        <md-card>
          <md-card-content>
            <md-table>
              <md-table-row>
                <md-table-head><b>Nota No</b></md-table-head>
                <md-table-head><b>Tanggal Nota</b></md-table-head>
                <md-table-head><b>PKB No</b></md-table-head>
                <md-table-head><b>Tanggal PKB</b></md-table-head>
                <md-table-head><b>Mengetahui</b></md-table-head>
                <md-table-head><b>Diperiksa</b></md-table-head>
                <md-table-head><b>Dibuat</b></md-table-head>
              </md-table-row>
              <md-table-row>
                <md-table-cell>{{nota_part.nota_part_no}}</md-table-cell>
                <md-table-cell>{{nota_part.nota_part_datetime}}</md-table-cell>
                <md-table-cell>{{nota_part.nota_part_pkb.pkb_no}}</md-table-cell>
                <md-table-cell>{{nota_part.nota_part_pkb.pkb_datetime}}</md-table-cell>
                <md-table-cell>{{nota_part.nota_part_mengetahui_name.name}}</md-table-cell>
                <md-table-cell>{{nota_part.nota_part_pkb.service_estimate.sa_name.name}}</md-table-cell>
                <md-table-cell>{{nota_part.nota_part_dibuat.name}}</md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>
        </md-card>
      </div>

      <div class="md-layout-item md-medium-size-200 md-xsmall-size-200 md-size-100" style="margin-top:10px;">
        <md-card>
          <md-card-header class="md-card-header-text md-card-header-primary">
            <div class="card-text">
              <h4 class="title">Client</h4>
            </div>
          </md-card-header>
          <md-card-content>
            <md-table>
              <md-table-row>
                <md-table-cell style="font-weight:bold; width:50mm;">Client Name</md-table-cell>
                <md-table-cell>{{nota_part.nota_part_pkb.service_estimate.client.client_name}}</md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell style="font-weight:bold; width:50mm;">Phone</md-table-cell>
                <md-table-cell>{{nota_part.nota_part_pkb.service_estimate.client.client_phone}}</md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell style="font-weight:bold; width:50mm;">Address</md-table-cell>
                <md-table-cell>{{nota_part.nota_part_pkb.service_estimate.client.client_address}}</md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell style="font-weight:bold; width:50mm;">Police No</md-table-cell>
                <md-table-cell>{{nota_part.vehicle_plate_no}}</md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell style="font-weight:bold; width:50mm;">Chassis No</md-table-cell>
                <md-table-cell>{{nota_part.vehicle_chasis_no}}</md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell style="font-weight:bold; width:50mm;">Vehicle Type</md-table-cell>
                <md-table-cell>{{nota_part.vehicle_model}}</md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>
        </md-card>
      </div>

      <div class="md-layout-item md-medium-size-200 md-xsmall-size-200 md-size-100" style="margin-top:10px;">
        <md-card>
          <md-card-header class="md-card-header-text md-card-header-primary">
            <div class="card-text">
              <h4 class="title">Spare Part</h4>
            </div>
          </md-card-header>
          <md-card-content>
           <md-table>
              <md-table-row>
                <md-table-head ><b>No</b></md-table-head>
                <md-table-head ><b>Spare Part Code</b></md-table-head>
                <md-table-head ><b>Spare Part Name</b></md-table-head>
                <md-table-head ><b>Qty</b></md-table-head>
                <md-table-head style="text-align:center;"><b>Price</b></md-table-head>
                <md-table-head style="text-align:center;"><b>Discount(%)</b></md-table-head>
                <md-table-head style="text-align:center;"><b>Total</b></md-table-head>
              </md-table-row>
              <md-table-row v-for="(item, index)  in nota_part.nota_part_part" :key="index">
                <md-table-cell >{{ index+1 }}</md-table-cell>
                <md-table-cell >{{ item.spare_part_master_code }}</md-table-cell>
                <md-table-cell >{{item.spare_part_master_name}}</md-table-cell>
                <md-table-cell>{{item.pkb_spare_part_qty}}</md-table-cell>
                <md-table-cell>
                  <span style="float: left;">Rp</span>
                  <span style="float: right;">{{ formatPrice(item.spare_part_master_unit_price) }}</span>
                </md-table-cell>
                <md-table-cell style="text-align:center;">{{ item.pkb_spare_part_discount }}</md-table-cell>
                <md-table-cell>
                  <span style="float: left;">Rp</span>
                  <span v-if="item.pkb_spare_part_discount" style="float: right;">{{formatPrice((item.pkb_spare_part_qty * item.spare_part_master_unit_price) - ((item.pkb_spare_part_qty * item.spare_part_master_unit_price) * item.pkb_spare_part_discount / 100 ))  }}</span>
                  <span v-else style="float: right;">{{formatPrice(item.pkb_spare_part_qty * item.spare_part_master_unit_price)  }}</span></md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell colspan="5"></md-table-cell>
                <md-table-cell style="text-align:center;"><b>Total</b></md-table-cell>
                <md-table-cell >
                  <span style="float: left;">Rp</span><span style="float: right;">{{formatPrice(total)}}</span>
                </md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>
        </md-card>
      </div>
    </div>


    <div  v-if="nota_part || nota_part != null" class="md-layout print">
      <div class="md-layout-item md-size-100">
          <md-content>
            <table class="noprint" style="width: 100%; table-layout: fixed; text-transform: capitalize ;">
             <colgroup>
               <col style="width: 7mm">
               <col style="width: 18mm">
               <col style="width: 20mm">
               <col style="width: 120mm">
               <col style="width: 15mm">
             </colgroup>
            <tr>
              <td ></td>
              <td></td>
              <td ></td>
              <td><md-button style="float: right; " class="noprint" @click="printPage()" ><md-icon>print</md-icon></md-button></td>
              <td >
                <md-menu md-direction="bottom-start">
                  <md-button class="nonprint; md-info" md-menu-trigger>Option</md-button>
                  <md-menu-content>
                    <md-menu-item v-if="role.update" @click="editNotaPart(nota_part.id)">Edit</md-menu-item>
                    <md-menu-item v-if="role.delete" @click="deleteConfirmation(nota_part.id)">Delete</md-menu-item>
                    <!-- <md-menu-item @click="backtoList">Back to NP list</md-menu-item> -->
                  </md-menu-content>
                </md-menu>
              </td>
            </tr>
          </table>
          <table class="print" style="width:100%; table-layout: fixed; border: 1px solid black;" >
            <tr>
              <td style="width:50mm; border: 1px solid black;"  rowspan="4"><img src="@/assets/images/logocharged.png" style="width:100%;"></td>
              <td style="padding-left:10mm; font-size: 4mm;  font-weight: 900; text-decoration: underline;">CHARGED INDONESIA</td>
            </tr>
            <tr>
              <td style="padding-left:10mm; font-size: 3.5mm; font-weight: 900;">JAKARTA</td>
            </tr>
            <tr>
              <td style="padding-left:10mm; font-size: 3.5mm; font-weight: 900;">Jl. Kemang Utara VII No.21B, Bangka, Kec. Mampang Prpt., Kota Jakarta Selatan, Daerah Khusus Ibukota Jakarta 12730</td>
            </tr>
            <tr>
              <td style="padding-left:10mm; font-size: 3.5mm; font-weight: 900;">Phone : 081280004426</td>
            </tr>
          </table>

          <table style="width:100%;  margin-top: 2px;" >
            <tr>
              <td style="width:75%"><b>NOTA SUKU CADANG DAN BAHAN</b></td>
            </tr>
          </table>

          <table style="width:100%;  margin-top: 3mm;" >
            <tr>
              <td style="width:80mm">
                <table id="font-size" style="width:100%; table-layout: margin-top: 2px;" >
                    <colgroup>
                    <col style="width:23mm">
                    <col style="width:5mm">
                    <col style="width:52mm">
                    </colgroup>
                  <tr>
                    <td ><b>Nomor</b></td>
                    <td ><b>:</b></td>
                    <td >{{nota_part.nota_part_no}}</td>
                  </tr>
                  <tr>
                    <td ><b>Tanggal</b></td>
                    <td ><b>:</b></td>
                    <td >{{nota_part.nota_part_datetime}}</td>
                  </tr>
                  <tr>
                    <td ><b>No. PKB</b></td>
                    <td ><b>:</b></td>
                    <td >{{nota_part.nota_part_pkb.pkb_no}}</td>
                  </tr>
                  <tr>
                    <td ><b>Tanggal PKB</b></td>
                    <td ><b>:</b></td>
                    <td >{{nota_part.nota_part_pkb.pkb_datetime}}</td>
                  </tr>
                  <tr>
                    <td ><b>No. Polisi</b></td>
                    <td ><b>:</b></td>
                    <td >{{nota_part.vehicle_plate_no}}</td>
                  </tr>
                  <tr>
                    <td ><b>No. Rangka</b></td>
                    <td ><b>:</b></td>
                    <td >{{nota_part.vehicle_chasis_no}}</td>
                  </tr> 
                  <tr>
                    <td ><b>Tipe</b></td>
                    <td ><b>:</b></td>
                    <td >{{nota_part.vehicle_model}}</td>
                  </tr>
                  
                </table>
              </td>
              <td style="width:100mm">
                <table id="font-size" style="width:100%; table-layout: fixed; border: 1px solid black; margin-top: 2px;" >
                  <tr>
                    <td style="width:17%"><b>KEPADA YTH :</b></td>
                  </tr>
                  <tr>
                    <td>{{nota_part.nota_part_pkb.service_estimate.client.client_name}}</td>
                  </tr>
                  <tr>&zwnj;</tr>
                  <tr>
                    <td>{{nota_part.nota_part_pkb.service_estimate.client.client_address}}</td>
                  </tr>
                  <tr>&zwnj;</tr>
                  <tr>
                    <td>{{nota_part.nota_part_pkb.service_estimate.client.client_phone}}</td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>

          <tr>&zwnj;</tr>
          <table style="width:100%;">
            <tr>
              <td style="width:41%"></td>
              <td ><b>SPAREPART</b></td>
            </tr>
          </table>

          <table class="table-kotak" style="border-collapse: width:100%; collapse; margin-top:10px; margin-bottom:10px;">
            <thead>
              <tr>
                <th class="title-name" style="width:10mm">No</th>
                <th class="title-name">Code Part</th>
                <th class="title-name" style="width:60mm">Name</th>
                <th class="title-name" style="width:10mm">QTY</th>
                <th class="title-name">Price</th>
                <th class="title-name">Disc(%)</th>
                <th class="title-name">Total</th>        
              </tr>
            </thead>
              <tr v-for="(item, index)  in nota_part.nota_part_part"
                    :key="index">
                      <td >{{ index+1 }}</td>
                      <td >{{ item.spare_part_master_code }}</td>
                      <td >{{ item.spare_part_master_name }}</td>
                      <td >{{ item.pkb_spare_part_qty }}</td>
                      <td ><span style="float: left;">Rp</span><span style="float: right;">{{ formatPrice(item.spare_part_master_unit_price) }}</span></td>
                      <td >{{ item.pkb_spare_part_discount }}</td>
                      <td ><span style="float: left;">Rp</span><span v-if="item.pkb_spare_part_discount" style="float: right;">{{formatPrice((item.pkb_spare_part_qty * item.spare_part_master_unit_price) - ((item.pkb_spare_part_qty * item.spare_part_master_unit_price) * item.pkb_spare_part_discount / 100 ))  }}</span>
                      <span v-else style="float: right;">{{formatPrice(item.pkb_spare_part_qty * item.spare_part_master_unit_price)  }}</span>
                      </td>
               
              </tr>
              <tr >
                <td colspan="5"></td>
                <td><b>Total</b></td>
                <td ><span style="float: left;">Rp</span><span style="float: right;">{{formatPrice(total)}}</span></td>
              </tr>
            </table>

            <table id="signature" style="width:100%;  margin-top: 2px;" >
              <colgroup>
                <col style="width:35mm;">
                <col style="width:35mm;">
                <col style="width:35mm;">
              </colgroup>
              <tr>
                <td style="text-align:center"><b>MENGETAHUI,</b></td>
                <td style="text-align:center"><b>DIPERIKSA OLEH,</b></td>
                <td style="text-align:center"><b>DIBUAT OLEH,</b></td>
              </tr>
              <tr>&zwnj;</tr>
              <tr>&zwnj;</tr>
              <tr>
                <td style="text-align:center"><sub>(</sub><span style="display:inline-block; border-bottom:1px solid black; padding-left:30px; padding-right:30px;">{{nota_part.nota_part_mengetahui_name.name}}</span><sub>)</sub></td>
                <td style="text-align:center"><sub>(</sub><span style="display:inline-block; border-bottom:1px solid black; padding-left:30px; padding-right:30px;">{{nota_part.nota_part_pkb.service_estimate.sa_name.name}}</span><sub>)</sub></td>
                <td style="text-align:center"><sub>(</sub><span style="display:inline-block; border-bottom:1px solid black; padding-left:30px; padding-right:30px;"></span><sub>)</sub></td>
              </tr>
            </table>
          </md-content>
          <!-- <button class="noprint" @click="printInvoice" >Print Invoice</button>
          <button class="noprint" @click="generateReport" >Print Invoice</button> -->
        
      </div>
    </div>
    
    <div v-bind:style="{ display: not_found}">
      <center  v-if="nota_part == null">
        <h1>Not Found!</h1>
        <p>
          <a href="" @click="backToList()">Go to List Nota Part?</a>
        </p>
      </center>
    </div>
  </div>
</template>

<script>
import {ValidationError} from "@/components";
import formMixin from "@/mixins/form-mixin";
import angkaTerbilang from '@develoka/angka-terbilang-js';
import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2';
import Swal from 'sweetalert2';

Vue.use(VueSweetalert2);

// import InfoCard from "@/pages/Dashboard/Workshop/ServiceEstimate/ComponentForm/InfoCard.vue";
// import ClientCard from "@/pages/Dashboard/Workshop/ServiceEstimate/ComponentForm/ClientCard.vue";
// import VehicleCard from "@/pages/Dashboard/Workshop/ServiceEstimate/ComponentForm/VehicleCard.vue";
// import ServiceCard from "@/pages/Dashboard/Workshop/ServiceEstimate/ComponentForm/ServiceCard.vue";
// import PartCard from "@/pages/Dashboard/Workshop/ServiceEstimate/ComponentForm/PartCard.vue";
  
export default {
  name: "detail-nota-part",

  props: {
    // service_estimate: Object,
    data_id:null,
  },

  components: {
    // ValidationError,
    // FormWizard,
    // TabContent,
    // "info-card": InfoCard,
    // "client-card": ClientCard,
    // "vehicle-card": VehicleCard,
    // "service-card": ServiceCard,
    // "part-card": PartCard,
      
  }, 

  mixins: [formMixin],

  data: () => ({
    not_found: 'none',
    role:'',
    nota_part: null,
    total:0
  }),

  created() {
    this.getNotaPartData();
  },

  methods: {
    //format uang
    formatPrice(value) {
      let val = (value/1).toFixed().replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
    
    //ambil data nota part dari api berdasarkan id yang ikut dikirim saat pindah page melalui route
    async getNotaPartData(){
          
      this.role =  await this.$store.getters["role_permission/route_filter"]
      await this.$store.dispatch("workshop_nota_part/get", this.data_id.id)
      this.nota_part = await this.$store.getters["workshop_nota_part/nota_part"]

       //check apakah data dari api ada
        if(!this.nota_part){
          //jika tidak ada munculkan bagian not found yang defaultnya di hide
          this.not_found = "block"
          return
        }

      this.calculateTotal();
      
      // this.nota_part.faktur_total_terbilang =  angkaTerbilang(this.faktur.faktur_total_biaya_jasa + this.faktur.faktur_total_biaya_spare_part + this.faktur.faktur_materai + this.faktur.faktur_ppn)
     // console.log(await this.$store.getters["workshop_nota_part/nota_part"])
      this.nota_part.vehicle_chasis_no = null
      this.nota_part.vehicle_plate_no = null
      this.nota_part.vehicle_model = null
      if(this.nota_part.nota_part_pkb.service_estimate.vehicle_types){
          this.nota_part.vehicle_chasis_no = this.nota_part.nota_part_pkb.service_estimate.vehicle_types.vehicle_chassis_no
          this.nota_part.vehicle_plate_no = this.nota_part.nota_part_pkb.service_estimate.vehicle_types.vehicle_plate_no
          this.nota_part.vehicle_model = this.nota_part.nota_part_pkb.service_estimate.vehicle_types.vehicle_types.vehicle_brands.vehicle_brand_name+', '+ this.nota_part.nota_part_pkb.service_estimate.vehicle_types.vehicle_types.vehicle_model+' '+ this.nota_part.nota_part_pkb.service_estimate.vehicle_types.vehicle_types.vehicle_year_model

      }
     
    
    },

    closeDetail(){
      //check apakah di props data id ada data modal_ref
      if(this.data_id.modal_ref){
        this.data_id.modal_ref.closeModal()
      }
      else if(this.data_id.mode && this.data_id.mode == "pkb"){
          this.$parent.$parent.modalCloseShowNotaPart();
        }
        else{
          this.$parent.$parent.modalCloseDetail();

        }
    },

    //pindah ke page edit.
    editNotaPart(id) {
      //push ke page edit beserta dengan id nota Part
      this.$router.push({ name: 'Edit Nota Part', params: { nota_part:id, id } })
    },

    // fungsi tombol kembali ke list nota part
    backToList() {
      this.$router.replace({ name: 'List Nota Part'})
    },

    // konfirmasi delete
    deleteConfirmation(id) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You wont be able to revert this!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!',
        buttonsStyling: true
      }).then((result) => {
        if (result.value){
          this.deleteNotaPart(id)
        }
      });
    },

    // fungsi hapus data
    async deleteNotaPart(id) {
      try {
        //kirim data yang akan di hapus ke api
        await this.$store.dispatch("workshop_nota_part/destroy", id)
        // panggil alert success
        await this.$store.dispatch("alerts/success", "Nota Part delete successfully.")
        // kembali ke list nota part
        this.$router.replace({ name: 'List Nota Part'})
      } catch (e) {
        // panggil alert error
        await this.$store.dispatch("alerts/error", "Oops, something went wrong!")
        this.setApiValidation(e.response.data.errors)
      }
    },

    // fungsi penjumlahan total
    calculateTotal(){
      console.log(this.nota_part.nota_part_part)
      var total = 0;
      this.nota_part.nota_part_part.map(function(value, key) {
        // jika tanpa discount, dilakukan penjumlahan tanpa discount
        if(value.pkb_spare_part_discount == null){
          total = total + (value.spare_part_master_unit_price * value.pkb_spare_part_qty)
        } else{
          // penjumlahan beserta discount
          total = total + (value.spare_part_master_unit_price * value.pkb_spare_part_qty) - ((value.spare_part_master_unit_price * value.pkb_spare_part_qty) * value.pkb_spare_part_discount / 100) 
        }
           
      });
      this.total = total
    },

    
    

    // fungsi tombol print
    printPage(){
      window.print()
    }
  }
};
</script>
<style scoped>
.title-name{
  background-color:powderblue;
}
table{
  width:100%;
  table-layout: fixed;
}
.table-kotak{
  border-collapse: collapse;
}
table.table-kotak td{
  border: 1px solid black;
  padding-left: 5px;
  padding-right: 5px;
  text-align: center;
}
table.table-kotak th{
  border: 1px solid black;
  padding-left: 5px;
  padding-right: 5px;
}
.print{
  visibility: hidden;
}
.checkboxes label {
  display: inline-block;
  padding-right: 10px;
  white-space: nowrap;
}
.checkboxes input {
  vertical-align: middle;
}
.checkboxes label span {
  vertical-align: middle;
}
.checkboxes td {
  padding: 0px;
  line-height: 0px;
  margin: 0px;
}
.checkboxes {
  padding: 0px;
  line-height: 0px;
  margin: 0px;
}
.info {
  line-height: 17px;
}
.info td {
margin: 4px;
}
.bold-title{
font-weight:bold;
}


.table-inside-td td {
  vertical-align: top;
  text-align: left;
  padding-left: 5px;
  padding-right: 5px;
}


@media print{
  .print{
    visibility: visible;
  }
  .noprint{
    display: none;
  }
}

/* .md-layout{
  background-color: white;
} */

.md-card{
  box-shadow: 0 3px 5px 1px rgb(0 0 0/ 14%);
}

.color{
  background-color: #1976d2 !important;
}
</style>